/**
 * `addedManually` is set only by the cut form's own "add" actions. It is
 * deliberately NOT read from `parameters.is_manual`: the backend sets that flag
 * on segment presences created by hand, so preview entries can carry it too and
 * would be re-added on every refresh, duplicating themselves.
 */
function mergePreviewEnrichments<T extends object>(previous: T[], incoming: T[]): T[] {
  const addedManually = (entry: T) => 'addedManually' in entry && entry.addedManually;

  return [...previous.filter(addedManually), ...incoming];
}

export { mergePreviewEnrichments };
